import React from "react";
import Login from "../componentes/login/Login";

function Index() {
  return <Login />;
}

export default Index;
